import HttpCliente from '../HttpCliente';

export const usuario = {
    Id: undefined,
    FirstName: '',
    LastName: '',
    DateOfBirth: '',
    Country: '',
    IsExternal: false,
    Email: '',
    Password: '',
    PhoneNumber: '',
  };

export const loginModel = {
    Email: '',  // Cambio aquí
    Password: '',  // Cambio aquí
};

/**
 * POST method - Inicia sesión con un usuario
 * @param {loginUsuario} usuario a iniciar sesión
 * @return {Promise} Promesa de obtención
 */

export const loginUser = (loginUsuario, setLoginError, setToken) => {
    return new Promise((resolve, reject) => {
        HttpCliente.post("/Auth/Login", loginUsuario, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.data.status === 200) {
                const token = response.data.token; // El token devuelto por el servidor
                setToken(token); // Almacenar el token en el estado
                resolve(token); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setLoginError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        /*
        .then(response => {
            const token = response.data; // El token devuelto por el servidor
            setToken(token); // Almacenar el token en el estado
            resolve(token); // Resuelve la promesa con el token
        })
*/
        .catch(error => {
            if (error.response && error.response.data) {
                setLoginError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setLoginError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
        
        
    });
};

/**
 * POST method - Inicia sesión con un usuario
 * @param {loginUsuario} usuario a iniciar sesión
 * @return {Promise} Promesa de obtención
 */

export const loginAdminUser = (loginUsuario, setLoginError, setToken) => {
    return new Promise((resolve, reject) => {
        HttpCliente.post("/Auth/Login-admin", loginUsuario, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.data.status === 200) {
                const token = response.data.token; // El token devuelto por el servidor
                setToken(token); // Almacenar el token en el estado
                resolve(token); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setLoginError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        /*
        .then(response => {
            const token = response.data; // El token devuelto por el servidor
            setToken(token); // Almacenar el token en el estado
            resolve(token); // Resuelve la promesa con el token
        })
*/
        .catch(error => {
            if (error.response && error.response.data) {
                setLoginError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setLoginError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
        
        
    });
};

/**
 * POST method - Registra un nuevo usuario
 * @param {usuario} usuario a registrar
 * @param {Function} setRegisterError función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */
export const registerUser = (usuario, setRegisterError) => {
    return new Promise((resolve, reject) => {
        HttpCliente.post("/Usuario", usuario, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.data.status === 201) {
                resolve(response.data);
            } else {
                // Pasar un objeto con propiedad message
                setRegisterError({ message: response.data.message });
                reject(response.data.message);
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                // Pasar un objeto con propiedad message
                setRegisterError({ message: error.response.data.message });
                reject(error.response.data.message);
            } else {
                // Pasar un objeto con propiedad message
                setRegisterError({ message: "Error de conexión" });
                reject("Error de conexión");
            }
        });
    });
};
/**
 * GET method - Verifica el email de un usuario usando un token
 * @param {string} token - Token de verificación de email
 * @param {Function} setVerificationError - Función para establecer el estado de error
 * @return {Promise} Promesa de verificación
 */
export const verifyEmail = (token, setVerificationError) => {
    return new Promise((resolve, reject) => {
      HttpCliente.get(`/Auth/verificar-email?token=${token}`, {
        headers: {
          'accept': '*/*'
        }
      })
      .then(response => {
        if (response.data.status === 200) {
          resolve(response.data);
        } else {
          setVerificationError(response.data.message);
          reject(response.data.message);
        }
      })
      .catch(error => {
        let errorMessage = "Error de verificación";
        
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }
        
        setVerificationError(errorMessage);
        reject(errorMessage);
      });
    });
  };

/**
 * POST method - Solicita un código para restablecer contraseña
 * @param {string} email - Email del usuario
 * @return {Promise} Promesa de la solicitud
 */
export const requestPasswordReset = (email) => {
    return new Promise((resolve, reject) => {
        HttpCliente.post("/Auth/forgot-password", { email }, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.data.status === 200) {
                resolve(response.data);
            } else {
                reject(response.data.message);
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                reject(error.response.data.message);
            } else {
                reject("Error de conexión");
            }
        });
    });
};

/**
 * POST method - Verifica el código de recuperación
 * @param {string} email - Email del usuario
 * @param {string} resetCode - Código de recuperación
 * @return {Promise} Promesa de la verificación
 */
export const verifyResetCode = (email, resetCode) => {
    return new Promise((resolve, reject) => {
        HttpCliente.post("/Auth/verify-reset-code", { email, resetCode }, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.data.status === 200) {
                resolve(response.data);
            } else {
                reject(response.data.message);
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                reject(error.response.data.message);
            } else {
                reject("Error de conexión");
            }
        });
    });
};

/**
 * POST method - Restablece la contraseña
 * @param {Object} resetData - Datos para restablecer contraseña
 * @return {Promise} Promesa del restablecimiento
 */
export const resetPassword = (resetData) => {
    return new Promise((resolve, reject) => {
        HttpCliente.post("/Auth/reset-password", resetData, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.data.status === 200) {
                resolve(response.data);
            } else {
                reject(response.data.message);
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                reject(error.response.data.message);
            } else {
                reject("Error de conexión");
            }
        });
    });
};

/**
 * POST method - Reenvía el correo de verificación
 * @param {Object} data - Objeto con el email del usuario
 * @param {Function} setError - Función para establecer el estado de error
 * @return {Promise} Promesa de la solicitud
 */
export const reenviarVerificacion = (data, setError) => {
    return new Promise((resolve, reject) => {
      HttpCliente.post("/Auth/reenviar-verificacion", data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        if (response.data.status === 200) {
          resolve(response.data);
        } else {
          setError(response.data.message);
          reject(response.data.message);
        }
      })
      .catch(error => {
        if (error.response && error.response.data) {
          setError(error.response.data.message);
          reject(error.response.data.message);
        } else {
          setError("Error de conexión");
          reject("Error de conexión");
        }
      });
    });
  };

/**
 * POST method - Inicia sesión con Google
 * @param {string} idToken token de Google
 * @param {Function} setLoginError función para establecer el estado de error
 * @param {Function} setToken función para establecer el token
 * @return {Promise} Promesa de obtención
 */
export const loginWithGoogle = (idToken, setLoginError, setToken) => {
    return new Promise((resolve, reject) => {
      HttpCliente.post("/Auth/google-login", { idToken }, {
        headers: {
          'Content-Type': 'application/json',
          'accept': '*/*'
        }
      })
      .then(response => {
        if (response.data.status === 200) {
          const token = response.data.token;
          setToken(token);
          resolve(token);
        } else {
          setLoginError(response.data.message || 'Error en inicio de sesión con Google');
          reject(response.data.message);
        }
      })
      .catch(error => {
        if (error.response && error.response.data) {
          setLoginError(error.response.data.message);
          reject(error.response.data.message);
        } else {
          setLoginError("Error de conexión");
          reject("Error de conexión");
        }
      });
    });
  };